import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "kt_drawer_license_info",
  "data-kt-drawer": "true",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-name": "license_info",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#kt_drawer_license_info_button",
  "data-kt-drawer-close": "#kt_drawer_license_info_close",
  "data-kt-drawer-width": "50.5vw"
}
const _hoisted_2 = {
  id: "kt_license_info",
  class: "card shadow-none border-0",
  style: {"width":"72.5vw"}
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header bg-primary text-light\" id=\"kt_license_info_header\"><h2 class=\"fw-bolder text-light my-auto\"> Trainee License Information Update </h2><div class=\"card-toolbar\"><button type=\"button\" class=\"btn btn-sm btn-icon btn-active-primary-light me-n5\" id=\"kt_drawer_license_info_close\"><i class=\"fas fa-times text-light\"></i></button></div></div>", 1)
const _hoisted_4 = {
  class: "card-body position-relative",
  id: "kt_license_info_body",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-wrappers": "#kt_license_info_body",
  "data-kt-scroll-dependencies": "#kt_license_info_header, #kt_license_info_footer",
  "data-kt-scroll-offset": "5px"
}
const _hoisted_5 = { class: "position-relative" }
const _hoisted_6 = ["validation-schema"]
const _hoisted_7 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_license_info_scroll"
}
const _hoisted_8 = { class: "row mb-7" }
const _hoisted_9 = { class: "col-md-12" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "License No")
], -1)
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "Application Date")
], -1)
const _hoisted_13 = { class: "col-md-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "Given Date")
], -1)
const _hoisted_15 = { class: "col-md-4" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "Expiry Date")
], -1)
const _hoisted_17 = {
  class: "card-footer py-5 text-center",
  id: "kt_license_info_footer"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("button", {
  type: "reset",
  id: "kt_license_info_cancel",
  class: "btn btn-secondary me-5"
}, " Discard ", -1)
const _hoisted_19 = ["data-kt-indicator"]
const _hoisted_20 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_21 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_22 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_form, {
            onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
            model: _ctx.formData,
            rules: _ctx.rules,
            ref: "formRef"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "card-body p-2",
                "validation-schema": _ctx.TraineeListSchema
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createVNode(_component_el_form_item, { prop: "license_number" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.license_number,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.license_number) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _createVNode(_component_el_form_item, { prop: "application_date" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.formData.application_date,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.application_date) = $event)),
                            "value-format": "YYYY-MM-DD",
                            format: "DD-MM-YYYY",
                            type: "date",
                            name: "application_date",
                            style: {"width":"100%"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createVNode(_component_el_form_item, { prop: "given_date" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.formData.given_date,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.given_date) = $event)),
                            "value-format": "YYYY-MM-DD",
                            format: "DD-MM-YYYY",
                            type: "date",
                            name: "given_date",
                            style: {"width":"100%"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createVNode(_component_el_form_item, { prop: "expiry_date" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.formData.expiry_date,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.expiry_date) = $event)),
                            "value-format": "YYYY-MM-DD",
                            format: "DD-MM-YYYY",
                            type: "date",
                            name: "expiry_date",
                            style: {"width":"100%"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ], 8, _hoisted_6),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("button", {
                  "data-kt-indicator": _ctx.loading ? 'on' : null,
                  class: "btn btn-lg btn-primary",
                  type: "submit",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.formSubmit()))
                }, [
                  (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                        _createTextVNode(" Submit "),
                        _createElementVNode("span", _hoisted_21, [
                          _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                        _createTextVNode(" Please wait... "),
                        _hoisted_23
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_19)
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ])
    ])
  ]))
}